import {
    CardContent,
    Grid,
    Typography,
    Button,
    Alert,
    Paper,
    Stack,
    Table,
    TableCell,
    TableRow,
    TableBody,
} from "@mui/material";
import { FunctionComponent, useEffect, useState } from "react";
import { Modal } from "../common/components/Modal";
import { useNavigate } from "react-router-dom";
import fleche2 from "../assets/fleche2.png";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { RouteApp } from "../common/model/RouteApp";
import {
    DisponibiliteStructure,
    ProfessionnelInterestedByStructure,
} from "../structures/model/StructureModel";
import "./StructureCard.css";
import { Item, ItemNight, refStatus } from "./WorkerCard";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import React from "react";
import { useAppDispatch } from "../common/redux/reduxHooks";
import {
    deleteProject,
    dispatchSmartAction,
} from "../structures/redux/projectAction";
import { SmartAcceptedCard } from "../common/components/SmartAcceptedCard";
import {
    CheckCircle,
    CheckCircleOutline,
    RemoveCircle,
    RemoveCircleOutline,
} from "@mui/icons-material";
import getTranslatedProfessionName from "../utils/getTranslatedProfessionName";

export const ManageStructureCard: FunctionComponent<DisponibiliteStructure> = (
    props: DisponibiliteStructure
) => {
    const [smartAccepted, setSmartAccepted] =
        useState<ProfessionnelInterestedByStructure>();
    const [isDisplayPopupDeleteProject, setisDisplayPopupDeleteProject] =
        React.useState<boolean>(false);
    const [rejectedInterestIds, setRejectedInterestIds] = useState<string[]>(
        []
    );

    const dispatch = useAppDispatch();

    useEffect(() => {
        const personnelValidate = props.interested?.filter(
            (v: ProfessionnelInterestedByStructure) =>
                v.status === refStatus.accepted
        );
        if (personnelValidate) {
            setSmartAccepted(personnelValidate[0]);
        }
    }, [props.interested]);

    const deleteDispo = () => {
        setisDisplayPopupDeleteProject(false);
        dispatch(deleteProject(props.id))
            .then(() => {
                navigate(RouteApp.MY_PROJECTS);
            })
            .catch((error: any) => {
                console.error("Failed to delete project:", error);
            });
    };

    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    function capitalizeFirstLetter(string: string) {
        if (string) {
            return string[0].toUpperCase() + string.slice(1);
        }
    }

    const approveSmart = async (id: string) => {
        const result = await dispatch(dispatchSmartAction(id, "approve"));
        if (result) {
            const approvedInterest = props.interested?.find(
                (v: ProfessionnelInterestedByStructure) => v.id === id
            );
            if (approvedInterest) {
                setSmartAccepted(approvedInterest);
            }
        }
    };

    const rejectSmart = async (id: string) => {
        const result = await dispatch(dispatchSmartAction(id, "reject"));
        if (result) {
            setRejectedInterestIds((prev) => [...prev, id]);
        }
    };

    return (
        <CardContainer>
            <StyledStack>
                <Title>
                    <Title>
                        {getTranslatedProfessionName(props.profession)}
                    </Title>
                </Title>
                <Grid sx={{ width: "100%" }}>
                    <Typography
                        gutterBottom
                        noWrap={true}
                        sx={{
                            textAlign: "center",
                            fontWeight: "bold",
                            width: "100%",
                            marginLeft: "0.5rem",
                        }}
                    >
                        {props.ville && `${props.ville} - `}
                        {props.administrativeArea?.name} -{" "}
                        {props.country &&
                            (t(
                                `country.${props.country.name
                                    .toLowerCase()
                                    .replace(/\s+/g, "")}`
                            ) ??
                                props.country.name)}{" "}
                    </Typography>
                </Grid>
                <Typography>{t("manageCards.period")}</Typography>
                <Grid
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <Typography
                        gutterBottom
                        variant="body2"
                        sx={{
                            backgroundColor: "#36454F",
                            color: "white",
                            p: 1,
                            borderRadius: "5px",
                        }}
                    >
                        {new Date(props.dateDemarrage).toLocaleDateString(
                            "fr-FR"
                        )}
                    </Typography>
                    <div>
                        <img
                            src={fleche2}
                            alt="Arrow"
                            style={{
                                width: "30px",
                                height: "30px",
                                zIndex: "10",
                                margin: 0.2,
                            }}
                        ></img>
                    </div>
                    <Typography
                        gutterBottom
                        variant="body2"
                        sx={{
                            backgroundColor: "#36454F",
                            color: "white",
                            p: 1,
                            borderRadius: "5px",
                        }}
                    >
                        {props.dateFin
                            ? new Date(props.dateFin).toLocaleDateString(
                                  "fr-FR"
                              )
                            : t("select.indifferent")}
                    </Typography>
                </Grid>
                <Typography>Selection</Typography>
                <Grid
                    container
                    mb={1}
                    spacing={1}
                    columns={16}
                    sx={{
                        justifyContent: "center",
                        gap: "0.5rem",
                    }}
                    flexWrap={"nowrap"}
                >
                    {props.selection &&
                        props.selection.map((e) => {
                            return e !== t("select.night") ? (
                                <Item>{capitalizeFirstLetter(e)}</Item>
                            ) : (
                                <ItemNight>
                                    {capitalizeFirstLetter(e)}
                                </ItemNight>
                            );
                        })}
                </Grid>
            </StyledStack>
            <CardContent>
                <Description>{props.description}</Description>
                {!props.enabled && (
                    <Alert
                        severity="info"
                        color="error"
                        sx={{
                            width: "100%",
                        }}
                    >
                        {t("project.validation")}
                    </Alert>
                )}

                {props.fulfilled && (
                    <Alert
                        color="success"
                        sx={{
                            width: "100%",
                        }}
                    >
                        {t("project.fulfilled")}
                    </Alert>
                )}

                {props.enabled && (
                    <div
                        style={{
                            width: "100%",
                            padding: "0.75rem",
                        }}
                    >
                        {!smartAccepted && (
                            <>
                                <Alert
                                    severity="info"
                                    sx={{
                                        fontSize: "14px",
                                        width: "100%",
                                    }}
                                >
                                    {props.interested?.length}{" "}
                                    {t("project.details.smart")}
                                </Alert>
                                {/* TODO: Move to a separate component */}
                                {(props.interested?.length ?? 0) > 0 && (
                                    <Grid container spacing={1} sx={{ mt: 2 }}>
                                        <Grid item xs={12}>
                                            <Typography
                                                variant="subtitle2"
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                {t("project.candidates")}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Paper
                                                variant="outlined"
                                                sx={{
                                                    width: "100%",
                                                    overflowX: "auto",
                                                }}
                                            >
                                                <Table size="small">
                                                    <TableBody>
                                                        {props.interested?.map(
                                                            (item) => (
                                                                <TableRow
                                                                    key={
                                                                        item
                                                                            .Professionnel
                                                                            ?.id
                                                                    }
                                                                >
                                                                    <TableCell>
                                                                        <p>
                                                                            {
                                                                                item
                                                                                    .Professionnel
                                                                                    ?.prenom
                                                                            }{" "}
                                                                            {
                                                                                item
                                                                                    .Professionnel
                                                                                    ?.nom
                                                                            }
                                                                        </p>
                                                                        <ProfessionalInformation>
                                                                            {item.Professionnel?.profession
                                                                                .map(
                                                                                    ({
                                                                                        translations,
                                                                                        name,
                                                                                    }) =>
                                                                                        translations?.[
                                                                                            i18n
                                                                                                .language
                                                                                        ] ??
                                                                                        name
                                                                                )
                                                                                .join(
                                                                                    ", "
                                                                                )}
                                                                        </ProfessionalInformation>
                                                                        <ProfessionalInformation>
                                                                            {
                                                                                item
                                                                                    .Professionnel
                                                                                    ?.telephone
                                                                            }
                                                                        </ProfessionalInformation>
                                                                        <ProfessionalInformation>
                                                                            {
                                                                                item
                                                                                    .Professionnel
                                                                                    ?.email
                                                                            }
                                                                        </ProfessionalInformation>
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {item.status ===
                                                                            "WAIT" &&
                                                                            !rejectedInterestIds.includes(
                                                                                item.id
                                                                            ) && (
                                                                                <>
                                                                                    <Button
                                                                                        size="small"
                                                                                        color="success"
                                                                                        variant="contained"
                                                                                        sx={{
                                                                                            minWidth: 0,
                                                                                            mr: 1,
                                                                                        }}
                                                                                        onClick={() =>
                                                                                            approveSmart(
                                                                                                item.id
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <CheckCircleOutline />
                                                                                    </Button>
                                                                                    <Button
                                                                                        size="small"
                                                                                        color="error"
                                                                                        variant="contained"
                                                                                        sx={{
                                                                                            minWidth: 0,
                                                                                        }}
                                                                                        onClick={() =>
                                                                                            rejectSmart(
                                                                                                item.id
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <RemoveCircleOutline />
                                                                                    </Button>
                                                                                </>
                                                                            )}
                                                                        {item.status ===
                                                                            "APPROUVED" && (
                                                                            <CheckCircle />
                                                                        )}
                                                                        {(item.status ===
                                                                            "REFUSED" ||
                                                                            rejectedInterestIds.includes(
                                                                                item.id
                                                                            )) && (
                                                                            <RemoveCircle />
                                                                        )}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                )}
                            </>
                        )}
                        {smartAccepted && (
                            <Paper>
                                <SmartAcceptedCard
                                    Professionnel={smartAccepted.Professionnel}
                                    status="ACCEPTED"
                                ></SmartAcceptedCard>
                            </Paper>
                        )}
                    </div>
                )}

                {!props.fulfilled && (
                    <Delete
                        color="error"
                        onClick={() => setisDisplayPopupDeleteProject(true)}
                        variant="contained"
                        size="large"
                        endIcon={<HighlightOffIcon />}
                    >
                        {t("button.delete.project")}
                    </Delete>
                )}
                <Modal
                    open={isDisplayPopupDeleteProject}
                    message={" "}
                    onCancel={() => setisDisplayPopupDeleteProject(false)}
                    titleButtonCancel={t("button.modal.cancel")}
                    title={t("project.delete.confirmation")}
                    onClose={() => setisDisplayPopupDeleteProject(false)}
                    onValidation={() => deleteDispo()}
                    titleButtonValidation={t("button.modal.valid")}
                    showBackground={false}
                ></Modal>
            </CardContent>
        </CardContainer>
    );
};

const CardContainer = styled(Paper)({
    marginTop: "1rem",
    borderRadius: "15px",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FAF9F6",
    width: "95dvw",
    height: "auto",
    boxShadow:
        "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",

    "@media(width >= 768px)": {
        width: "50dvw",
    },

    "@media (width >= 990px)": {
        width: "30dvw",
        padding: "1rem",
    },
});

const StyledStack = styled(Stack)({
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    alignItems: "center",
    height: "100%",
});

const Description = styled(Typography)({
    overflow: "auto",
    marginBottom: "1rem",
    textAlign: "center",
    width: "100%",
    padding: "0px 16px",
});

const Delete = styled(Button)({
    width: "100%",
    marginTop: "1rem",
    padding: "0.4rem",

    "@media(width >= 990px)": {},
});

const Title = styled(Typography)({
    fontSize: "20px",
    fontWeight: "bold",
    textAlign: "center",
    width: "100%",
    marginTop: "1rem",
    textDecoration: "underline",
});

const ProfessionalInformation = styled(Typography)({
    fontSize: "14px",
    color: "#555",
});
